export interface Configuration {
  allowOperationIds?: string[];
}
